import { User } from "@/@types/sintegrada/User";
import { getSintegradaServerApi } from "@/services/api";

type ProfissionalReceptionParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
	professionalName?: string;
	professionalCns?: string;
	professionalId?: number;
};

export async function getProfissionalReception({ ...params }: ProfissionalReceptionParams) {
	const response = await getSintegradaServerApi().get<User[]>(`/professional/reception`, params);
	return response.data || [];
}
